import {atom} from 'recoil';

export default atom<number>({
  key: 'preleadProjectsByMailCampaignTotalCountAtom',
  default: 0,
});
